import { AlertBlock, Breakpoint, Color, Disclaimer, FontWeight, Markdown } from '@elearning-platform/ui';
import { styled } from 'styled-components';

export const Container = styled.div`
  background: ${Color.Gray100};
  min-height: 100vh;
  width: 100%;
`;

export const Title = styled(Markdown)`
  color: ${Color.Gray700};
  font-size: 30px;
  line-height: 38px;
  padding: 40px;

  strong {  
    font-weight: ${FontWeight.Regular};
    color: ${Color.Gray500};
  }
`;

export const InfoBox = styled(Markdown)`
  display: block;
  padding: 24px;
  border-radius: 2px;
  background: ${Color.White};
  color: ${Color.Black100};
  font-size: 14px;
  line-height: 20px;

  strong {
    font-weight: ${FontWeight.SemiBold};
  }

  ul {
    list-style: disc;
    margin-left: 24px;
    line-height: 12px;
  }
`;

export const FieldsWrapper = styled.div`
  display: flex;
  padding: 24px 24px 28px 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  border-radius: 2px;
  border: 1px solid ${Color.Gray300};
`;

export const FieldLabel = styled(Markdown)`
  color: ${Color.Black100};
  font-size: 14px;
  font-weight: ${FontWeight.SemiBold};
  line-height: 20px;

  strong {
    font-weight: ${FontWeight.SemiBold};
  }
`;

export const CollapsibleSectionInner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const RadioInputs = styled.div`
  gap: 16px;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
`;

export const StyledDisclaimer = styled(Disclaimer)`
  margin: 24px 0;
`;

export const MobileImg = styled.img`
  height: 200px;
  object-fit: cover;
  width: 100%;

  @media ${Breakpoint.SmallDesktop} {
    display: none;
  }
`;

export const ColumnImg = styled.img`
  object-fit: contain;
  display: none;
  max-width: 100%;

  @media ${Breakpoint.SmallDesktop} {
    display: inline;
  }
`;

export const FormColumn = styled.div`
  width: 100%;

  @media ${Breakpoint.SmallDesktop} {
    max-width: 867px;
  }
`;

export const FormWrapper = styled.div`
  border-right: 1px solid ${Color.Gray300};
  border-bottom: 1px solid ${Color.Gray300};
`;

export const FormStep = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  gap: 10px;
`;

export const StyledAlertBlock = styled(AlertBlock)`
  width: 100%;
`;
